import Grid from "@mui/material/Grid";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { ResumenCuentaList } from "../components/ResumenCuentaList";

export function ResumenCuenta() {
  return (
    <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
      <PageHeaderCard title="Resumen de Cuenta" icon={<AccountBalanceWalletIcon />} />
      <ResumenCuentaList />
    </Grid>
  );
}
